<mat-drawer-container>
  <!-- Header (Logo bar) -->
  @if (!smallScreen) {
    <div id="headerBar">
      <div id="headerBarCapWidth">
        <span class="flex">
          <a [routerLink]="''">
            <img id="headerLogo" src="assets/images/logo/wa_logo_white_yellow.svg" />
          </a>
        </span>
        <ng-container>
          <span class="flex">
            <button mat-button class="headerBarItem" [routerLink]="'/cart/checkout'">
              <mat-icon [svgIcon]="'feather:shopping-cart'" matBadgePosition="before" [matBadge]="cartSummary?.itemsCount"
              matBadgeColor="accent"></mat-icon>
              <span color="white">Cart</span>
            </button>
            @if (!user) {
              <button mat-button class="headerBarItem" (click)="login()">
                <mat-icon [svgIcon]="'feather:log-in'"></mat-icon>
                <span>Login</span>
              </button>
            }
            @if (user) {
              <button mat-button class="headerBarItem" [matMenuTriggerFor]="loggedInAccountMenu">
                <mat-icon [svgIcon]="'feather:user'"></mat-icon>
                <span>{{user?.first_name}}</span>
              </button>
            }
          </span>
        </ng-container>
      </div>
    </div>
  }

  @if (smallScreen) {
    <div id="smallHeaderBar">
      <div class="flex w-full space-between">
        <span class="flex smallHeaderLogo">
          <a [routerLink]="''">
            <img id="headerLogo" src="assets/images/logo/wa_logo_white_yellow.svg" />
          </a>
        </span>
        <div class="mobileActionItems">
          <button mat-button [routerLink]="'/cart/checkout'">
            <mat-icon [svgIcon]="'feather:shopping-cart'" matBadgePosition="before" [matBadge]="cartSummary?.itemsCount"
            matBadgeColor="accent"></mat-icon>
            <span>Cart</span>
          </button>
          @if (!user) {
            <button mat-button (click)="login()">
              <mat-icon [svgIcon]="'feather:log-in'"></mat-icon>
              <span>Login</span>
            </button>
          }
          @if (user) {
            <button mat-button [matMenuTriggerFor]="loggedInAccountMenu">
              <mat-icon [svgIcon]="'feather:user'"></mat-icon>
              <span>{{user?.first_name}}</span>
            </button>
          }
        </div>
      </div>
    </div>
  }

  @if (extraSmallScreen && !smallScreen) {
    <div class="navigationAndSearchBar">
      <div class="flex">
        <div class="menuText">
          <button mat-button (click)="openNavigation()">
            <mat-icon svgIcon="feather:menu" class="menuIconWidth"></mat-icon>
          </button>
        </div>
        <div class="smallSearch">
          <div class="justify-center searchBar">
            <mat-form-field class="smallSearchControl" appearance="fill">
              <input matInput [formControl]="formGroup?.get('searchText') | formControl" class="flex-grow" placeholder="Search"
              (keydown.enter)="search()">
                <button mat-button matSuffix (click)="search()"><mat-icon [svgIcon]="'feather:search'"></mat-icon></button>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    }

    @if (smallScreen) {
      <div class="navigationAndSearchBar">
        <div class="flex w-full">
          <div class="menuText">
            <button mat-button (click)="openNavigation()">
              <mat-icon svgIcon="feather:menu" class="menuIconWidth"></mat-icon>
            </button>
          </div>
          <div class="smallSearch">
            <div class="justify-center searchBar w-full">
              <mat-form-field class="smallSearchControl" appearance="fill">
                <input matInput [formControl]="formGroup?.get('searchText') | formControl" class="flex-grow" placeholder="Search"
                  (keydown.enter)="search()">
                  <button mat-button matSuffix (click)="search()"><mat-icon [svgIcon]="'feather:search'"></mat-icon></button>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      }



      @if (!smallScreen) {
        <div class="navigationAndSearchBar capWidth">
          <div class="flex">
            <div class="flex menuText">
              <button mat-button (click)="openNavigation()">
                <mat-icon svgIcon="feather:menu" class="menuIconWidth"></mat-icon>
                Menu
              </button>
            </div>
          </div>
          <!-- SEARCH  -->
          <div class="flex flex-grow justify-center searchBar">
            <div class="searchBarWrapper flex flex-grow">
              <mat-form-field appearance="fill" class="searchControl" id="searchDropDown">
                <mat-select [formControl]="formGroup?.get('type') | formControl">
                  @for (type of searchTypes; track type) {
                    <mat-option [value]="type.value">{{ type.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="fill" class="searchControl w-full">
                <input matInput [formControl]="formGroup?.get('searchText') | formControl" class="flex-grow" placeholder="Search"
                  (keydown.enter)="search()">
                  <button mat-button matSuffix (click)="search()"><mat-icon [svgIcon]="'feather:search'"></mat-icon></button>
                </mat-form-field>
              </div>
            </div>
          </div>
        }

        <div id="navigationDropDown">
          @if (showNav) {
            <app-navigation-menu [navItem]="currentNavItem"
            (mouseleave)="showNav = false"></app-navigation-menu>
          }
        </div>
        @if (routeStepCount > 0) {
          <div id="breadCrumbBar">
            <div id="breadCrumbWidthCap">
              <xng-breadcrumb></xng-breadcrumb>
              @if (timeRemaining) {
                <div class="cartTimerContainer" [ngClass]="{'warningTimer' : timeUnderTenMins}">
                  <mat-button class="" routerLink="/cart/checkout">
                    <mat-icon [svgIcon]="'feather:shopping-cart'"></mat-icon>
                    Cart expires in <strong [ngClass]="{'warningText': timeUnderTenMins}">{{ timeRemaining }}</strong>
                  </mat-button>
                </div>
              }
            </div>
          </div>
        }
        <div class="router-content-container">
          @if (true) {
            <router-outlet (activate)="changedRoute()"></router-outlet>
          }
        </div>

        <footer id="footer">
          <div id="siteMap">
            <div id="siteMapCapWidth" [ngClass]="{'footerSmallScreen': smallScreen}">
              <div class="footerSiteMapColumn">
                <label class="footerHeader">Shop</label>
                <a href="/category/listings">Wines</a>
                <a href="/accessories">Accessories</a>
              </div>
              <div class="footerSiteMapColumn">
                <label class="footerHeader">About</label>
                <a href="/about">About us</a>
                <a href="/about/why-wine-ark">Why join?</a>
              </div>
              <div class="footerSiteMapColumn">
                <label class="footerHeader">Help</label>
                <a href="/resources/faq">FAQ</a>
                <a [href]="getTermsAndConditionsUrl()">Terms and conditions</a>
              </div>
              <div class="footerSiteMapColumn">
                <label class="footerHeader">Contact</label>
                <span class="content-center flex footerIcon"><mat-icon [svgIcon]="'feather:phone'"></mat-icon><a
              href="tel:1300 946 327">1300 946 327</a></span>
              <span class="content-center flex footerIcon"><mat-icon [svgIcon]="'feather:mail'"></mat-icon><a
            href="contact">Email us</a></span>
            <label class="footerHeader">Follow us</label>
            <span>
              <a href="https://twitter.com/wineark"><mat-icon [svgIcon]="'feather:twitter'"></mat-icon></a>
              <a href="https://www.facebook.com/wineark"><mat-icon [svgIcon]="'feather:facebook'"></mat-icon></a>
              <a href="https://www.instagram.com/wine_ark"><mat-icon [svgIcon]="'feather:instagram'"></mat-icon></a>
            </span>
          </div>
          <div class="footerSiteMapColumn">
            <a href="https://www.wineark.com.au">
              <img src="assets/images/logo/ns_wa_logo_white_yellow.svg">
            </a>
          </div>
        </div>
      </div>
      <div id="copyright">
        <p>© Wine Ark. All rights reserved.</p>
        <p>It is against the law to sell or supply alcohol to, or to obtain alcohol on behalf of, a person under the age
        of 18 years. Licence number: LIQP770010044</p>
      </div>
    </footer>

    @if (navigationOpenStatus()) {
      <div class="nav-overlay" (click)="closeNavigation()"></div>
    }

  </mat-drawer-container>

  <mat-drawer #newNav mode="over" position="start" class="newNavDrawer">
    <app-navigation [drawer]="newNav"></app-navigation>
  </mat-drawer>

  <mat-menu #loggedInAccountMenu="matMenu" class="accountMenu">
    <div class="accountMenu">
      @if (user) {
        <button class="accountMenuItem" mat-menu-item (click)="navigateToAccount()">
          <mat-icon [svgIcon]="'hero_outline:user-circle'"></mat-icon>
          My account
        </button>
      }

      <button class="accountMenuItem" mat-menu-item (click)="navigateToCellar()">
        <mat-icon [svgIcon]="'feather:archive'"></mat-icon>
        My cellar
      </button>

      <button class="accountMenuItem" mat-menu-item [routerLink]="'/watchlist'">
        <mat-icon [svgIcon]="'feather:heart'"></mat-icon>
        Watchlist
      </button>

      @if (user) {
        <button class="accountMenuItem" mat-menu-item (click)="logout()">
          <mat-icon [svgIcon]="'feather:log-out'"></mat-icon>
          Logout
        </button>
      }
    </div>
  </mat-menu>